import { Router } from 'vue-router'
import { getEnv, getParams, getQueryParam } from '@/utils'
import SSOClient from '@kuailu/sso'
import axios from 'axios'
import { router as R_router } from '@/router'

async function getWeComConfig(WeCom_baseUrl) {
  window.$ww = await import('@wecom/jssdk')
  console.log('WeCom:', $ww.SDK_VERSION)
  console.log(WeCom_baseUrl)

  const { data }: any = await axios.post(
    '/wx/wxToken/weCom/getConfiguration',
    {},
    {
      baseURL: WeCom_baseUrl
    }
  )
  const res = data
  if (res.code === '200') {
    return { ...res.data }
  }
}

export function createPermissionGuard(router: Router) {
  router.beforeEach(async (to) => {
    // 企微
    if (window.location.search && getQueryParam('state') === 'WeCom') {
      if (to.name === 'dontInstallWeComApp') {
        return true
      }
      const WeCom_baseUrl = ref<any>('')

      SSOClient.init({
        clientId: getParams('clientId') || 'saas',
        projectId: 'saas-auth',
        env: getEnv()
      })

      WeCom_baseUrl.value = SSOClient['WeCom_baseUrl']

      const WeCom_config: any = await getWeComConfig(WeCom_baseUrl.value)

      const code = getQueryParam('code')

      const _res = await SSOClient.initWeCom({
        code: code,
        requestFrom: '2',
        ww_register_options: {
          jsApiList: [
            'getExternalContact',
            'checkJsApi',
            'getContext',
            'getNetworkType',
            'initOpenData'
          ],
          onConfigSuccess: () => {
            console.log('企业微信注册sdk注册成功')
          },
          onConfigFail: (errMsg: any) => {
            console.log('企业微信注册sdk注册失败', errMsg)
          },
          onAgentConfigSuccess: () => {
            console.log('企业微信注册 getAgentConfigSignature 成功')
          },
          onAgentConfigFail: (errMsg: any) => {
            console.log('企业微信注册 getAgentConfigSignature 失败', errMsg)
          }
        }
      })

      if (Object.keys(_res).length > 0) {
        // 检测系统是否有改账号
        const _res2: any = await axios.post(
          '/wx/wxToken/weCom/isInstall',
          { code },
          {
            baseURL: WeCom_baseUrl.value
          }
        )

        const _data_res2 = _res2.data
        console.log(_data_res2)

        if (_data_res2.code === '200') {
          if (_data_res2.data) {
            window.location.replace(WeCom_config.authRedirectUrl + `/#/?code=${code}&state=WeCom`)
          } else {
            await R_router.push({
              name: 'dontInstallWeComApp',
              query: {
                promotionQRCode: encodeURIComponent(WeCom_config.promotionQRCode || '')
              }
            })
          }
        }
      } else {
        window.$message.error('初始化企微错误')
      }
      return false
    }

    if (to.path === '/') {
      return { path: 'login' }
    }
    if (to.path === '/h5/') {
      return { path: '/h5/login' }
    }
    return true
  })
}
